/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../components/sectionTitle';
import Quiz from '../../components/quiz';
import Conversation from './conversation';
import Animation002 from './animation002';
import Animation004 from './animation004';
import Animation006 from './animation006';
import Animation011 from './animation011';
import Animation014 from './animation014';
import Animation023 from './animation023';
import Animation025 from './animation025';
import Animation045 from './animation045';
import Animation028 from './animation028';
import Animation033 from './animation033';
import Animation037 from './animation037';
import Animation041 from './animation041';
import Animation043 from './animation043';
import Animation044 from './animation044';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation002,
  Animation004,
  Animation006,
  Animation011,
  Animation014,
  Animation023,
  Animation025,
  Animation028,
  Animation033,
  Animation037,
  Animation041,
  Animation043,
  Animation044,
  Animation045,
  Component001,
  Component002,
  Component003,
  Component004,
};

export default Components;
